import React from "react"
import { Link } from "react-router-dom"
import IconButtonUI from "../../../widgets/action/IconButtonUI"
import FloatingMessageUI from "../../../widgets/form/FloatingMessageUI"
import FileUploadModalSF from "../../../widgets/form/FileUploadModalSF"
import LRTableActionsUI from "../../../widgets/layout/LRTableActionsUI"
import SuperUserLoanPageSF from "../../../templates/SuperUserLoanPageSF"
import SpinnerComponentUI from "../../../components/common/SpinnerComponentUI"
import './LoanCashFlowListPage.css'

const LoanCashFlowListPageUI = ({
  context, errorList, successMsg, cashFlowList, loan, onRefreshClick, cashFlowDownloadRequested, onDownloadCashFlowTemplate,
  cashFlowsUploadMode, onCashFlowsUploadClick, onCashFlowsUploadCancel, cashFlowsSignedUrlApi, onCashFlowsUpload,
}) =>
  <SuperUserLoanPageSF context={context} className='pg_su_lcf'
    headerText='Projected Cash Flows' centered={!cashFlowList && !errorList}
    loan={loan} page='cashFlow' dimension='w1600'
  >
    {
      (!cashFlowList || !errorList) &&
      <SpinnerComponentUI />
    }

    {
      cashFlowList &&
      <div>
        <LRTableActionsUI
          location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
              <IconButtonUI icon='icon-download' onClick={onDownloadCashFlowTemplate} label='Download cash flow template' />
              <span className='g_m_left_100 g_large'><b>Projected Cash Flows</b></span>
            </span>
          }
          right={
            <Link to='#' className='g_m_right_100' onClick={onCashFlowsUploadClick}>Upload cash flows</Link>
          }
        />

        <FloatingMessageUI errorList={errorList} success={successMsg} />

        <LoanCashFlowListUI cashFlowList={cashFlowList} />
      </div>
    }

    <FileUploadModalSF
      context={context}
      uploadMode={cashFlowsUploadMode}
      onCancelClick={onCashFlowsUploadCancel}
      signedUrlApi={cashFlowsSignedUrlApi}
      onUpload={onCashFlowsUpload}
      hint='Upload cash flow .xlsx or .xls file as per the template'
    />

  </SuperUserLoanPageSF>

const LoanCashFlowListUI = ({ cashFlowList }) => {
  return (
  <div className='cf_table_wrap'>
    <table className='g_table cf_table'>
      <thead>
        <tr className='cf_period_row'>
          <th>Period (in months)</th>
          {
            cashFlowList.map((cashFlow, i) =>
              <th key={i}>{cashFlow.yearMonthFormatted}</th>
            )
          }
        </tr>
      </thead>
      <tbody>
        <RowUI cashFlowList={cashFlowList} name='Opening Balance' value='openingBalance' isBold={true} />
        <SectionHeaderRow cashFlowList={cashFlowList} label='Sources and Uses for the Project' />
        <SectionHeaderRow cashFlowList={cashFlowList} label='Sources' />
        <RowUI cashFlowList={cashFlowList} name='Promoter Contribution' value='promoterContribution' />
        <RowUI cashFlowList={cashFlowList} name=' - For Project' value='forProject' indent />
        <RowUI cashFlowList={cashFlowList} name=' - For EMI' value='forEmi' indent />
        <RowUI cashFlowList={cashFlowList} name=' - For DSRA' value='forDsra' indent />
        <RowUI cashFlowList={cashFlowList} name=' - For Upfront Fee' value='forUpfrontFee' indent />
        <RowUI cashFlowList={cashFlowList} name='Clime Finance loan' value='climeFinanceLoan' />
        <RowUI cashFlowList={cashFlowList} name='Receivables from Project' value='receivablesFromProject' />
        <RowUI cashFlowList={cashFlowList} name='Sub Total' value='sourcesSubTotal' isBold={true} />
        <SectionHeaderRow cashFlowList={cashFlowList} label='Uses' />
        <RowUI cashFlowList={cashFlowList} name='Capital Expenditure' value='capitalExpenditure' />
        <RowUI cashFlowList={cashFlowList} name='DSRA Creation' value='dsraCreation' />
        <RowUI cashFlowList={cashFlowList} name='Upfront Fee' value='upfrontFee' />
        <CategoryLabelRow cashFlowList={cashFlowList} label='Loan Repayments' />
        <RowUI cashFlowList={cashFlowList} name=' - Principal' value='principal' indent />
        <RowUI cashFlowList={cashFlowList} name=' - Interest' value='interest' indent />
        <CategoryLabelRow cashFlowList={cashFlowList} label='Operations Costs' />
        <RowUI cashFlowList={cashFlowList} name=' - Payroll Costs' value='payrollCosts' indent />
        <RowUI cashFlowList={cashFlowList} name=' - Costs Other than Capex' value='costsOtherThanCapex' indent />
        <RowUI cashFlowList={cashFlowList} name=' - Insurance Costs' value='insuranceCosts' indent />
        <RowUI cashFlowList={cashFlowList} name=' - Other Finance Costs' value='otherFinanceCosts' indent />
        <RowUI cashFlowList={cashFlowList} name=' - Other Costs' value='otherCosts' indent />
        <RowUI cashFlowList={cashFlowList} name='Sub Total' value='usesSubTotal' isBold={true} />
        <RowUI cashFlowList={cashFlowList} name='Closing balance' value='closingBalance' isBold={true} />
      </tbody>
    </table>
  </div>
  )
}

const SectionHeaderRow = ({ cashFlowList, label }) =>
  <tr className='cf_section_header'>
    <td className='g_no_wrap_2 title'><b>{label}</b></td>
    {cashFlowList.map((_, i) => <td key={i} className='value' />)}
  </tr>

const CategoryLabelRow = ({ cashFlowList, label }) =>
  <tr className='cf_category_row'>
    <td className='g_no_wrap_2 title'><b>{label}</b></td>
    {cashFlowList.map((_, i) => <td key={i} className='g_text_right g_m_left_100 value' />)}
  </tr>

const formatAccounting = (raw, formatted) => {
  if(raw < 0) {
    return `(${formatted})`
  }
  return formatted
}

const RowUI = ({ cashFlowList, name, value, isBold, indent }) =>
  <tr>
    <td style={isBold ? { fontWeight: 'bold' } : {}} className={`g_no_wrap_2 title${indent ? ' cf_sub_label' : ''}`}>{name}</td>
    {
      cashFlowList.map((cashFlow, i) =>
        <td key={i} style={isBold ? { fontWeight: 'bold' } : {}} className='g_text_right g_m_left_100 value'>
          {formatAccounting(cashFlow[value], cashFlow[value + 'F5'])}
        </td>
      )
    }
  </tr>

export default LoanCashFlowListPageUI